import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVouchermagblack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.2 0c.442 0 .8.364.8.812v17.434c0 .26-.123.506-.332.659a.79.79 0 0 1-.72.112l-4.43-1.499-2.074 1.404a.79.79 0 0 1-.887 0l-2.075-1.404-4.43 1.499a.789.789 0 0 1-.72-.112.816.816 0 0 1-.332-.66V.813C0 .364.358 0 .8 0h14.4zM8.5 4a.833.833 0 0 0-.833.833v.154A2.496 2.496 0 0 0 6 7.334c0 1.378 1.122 2.5 2.5 2.5a.834.834 0 0 1 0 1.666.834.834 0 0 1-.833-.834.833.833 0 1 0-1.667 0c0 1.085.698 2.002 1.667 2.347v.154a.833.833 0 1 0 1.666 0v-.154A2.497 2.497 0 0 0 11 10.666c0-1.378-1.122-2.5-2.5-2.5a.834.834 0 1 1 .833-.833.833.833 0 1 0 1.667 0c0-1.085-.7-2.002-1.667-2.347v-.153A.833.833 0 0 0 8.5 4z",
		fill: "#2B2B2B",
		fillRule: "nonzero"
	})
});
export default SvgVouchermagblack;
